import { render, staticRenderFns } from "./ReviewWrite.vue?vue&type=template&id=1c92261e&scoped=true"
import script from "./ReviewWrite.vue?vue&type=script&lang=js"
export * from "./ReviewWrite.vue?vue&type=script&lang=js"
import style0 from "./ReviewWrite.vue?vue&type=style&index=0&id=1c92261e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92261e",
  null
  
)

export default component.exports